import { appRouter } from './pages/AppRouter';
import { RegisterProvider } from './Register';
import Home from './pages/Home';
import './App.css';
import Admin from "./pages/Admin";
import Tournament from "./pages/Tournament";
import AdminTournament from "./pages/admin/Tournament";
// ページ情報を定義して appRouter に設定
const pages = [
    { key: 'Home', path: '/', element: <Home /> },
    { key: 'Admin', path: '/admin', element: <Admin /> },
    { key: 'Tournament', path: '/tournament', element: <Tournament />},
    { key: 'AdminTournament', path: '/admin/tournament', element: <AdminTournament />}
];
const router = appRouter(pages);

const App = () => {
    return (
        <RegisterProvider>
            {/* 位置調整で main で括る */}
            <main>{router.browserRouter}</main>
        </RegisterProvider>
    );
};

export default App;